/* Kiomia - confronto prima e dopo.

   Il trascinamento lo gestiamo con gli eventi del puntatore, che valgono per
   dito, mouse e pennino insieme: l'input range da solo su iPhone si muove solo
   se il dito parte esattamente sul cursore, e il nostro cursore e' invisibile.
   Il range resta per la tastiera e per gli screen reader.

   In piu' c'e' il suggerimento: la prima volta che la sezione entra in vista la
   maniglia si sposta da sola e torna indietro. Senza, molti non capiscono che
   l'immagine si trascina e si perdono la cosa piu' convincente della pagina.
   Basta un accenno: appena la persona tocca, il suggerimento si ferma e non
   torna piu'.
*/
(function(){
  var FERMO = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function avvia(root){
    var nodi = (root || document).querySelectorAll('[data-km-cf]:not([data-km-cf-pronto])');
    Array.prototype.forEach.call(nodi, function(cf){
      cf.setAttribute('data-km-cf-pronto', '1');
      var cursore = cf.querySelector('.km-cf__range');
      var toccato = false;

      function metti(p){
        if (p < 0) p = 0;
        if (p > 100) p = 100;
        cf.style.setProperty('--x', p + '%');
        if (cursore) cursore.value = p;
      }

      if (cursore){
        var daTastiera = function(){ toccato = true; metti(parseFloat(cursore.value)); };
        cursore.addEventListener('input', daTastiera);
        cursore.addEventListener('change', daTastiera);
        metti(parseFloat(cursore.value) || 50);
      }

      var giu = false;
      function daPuntatore(e){
        var box = cf.getBoundingClientRect();
        if (!box.width) return;
        metti((e.clientX - box.left) / box.width * 100);
      }
      cf.addEventListener('pointerdown', function(e){
        giu = true; toccato = true;
        if (cf.setPointerCapture){ try { cf.setPointerCapture(e.pointerId); } catch(err){} }
        daPuntatore(e);
      });
      cf.addEventListener('pointermove', function(e){ if (giu) daPuntatore(e); });
      var molla = function(){ giu = false; };
      cf.addEventListener('pointerup', molla);
      cf.addEventListener('pointercancel', molla);
      cf.addEventListener('lostpointercapture', molla);

      if (!('PointerEvent' in window)){
        cf.addEventListener('touchstart', function(e){ toccato = true; daPuntatore(e.touches[0]); }, {passive:true});
        cf.addEventListener('touchmove', function(e){ daPuntatore(e.touches[0]); }, {passive:true});
      }

      /* Il suggerimento: 50 -> 68 -> 50, una volta sola. */
      if (FERMO || !window.requestAnimationFrame) return;
      var fatto = false;

      function visibile(){
        var r = cf.getBoundingClientRect();
        var h = window.innerHeight || document.documentElement.clientHeight;
        if (r.bottom < 0 || r.top > h) return false;
        var dentro = Math.min(r.bottom, h) - Math.max(r.top, 0);
        return dentro >= Math.min(r.height * 0.5, h * 0.4);
      }

      function accenna(){
        var inizio = null, durata = 1500, da = 50, a = 68;
        function passo(t){
          if (toccato) { return; }
          if (inizio === null) inizio = t;
          var q = Math.min((t - inizio) / durata, 1);
          /* va e torna: mezzo giro di seno, cosi' parte e rientra dolce */
          var onda = Math.sin(q * Math.PI);
          metti(da + (a - da) * onda);
          if (q < 1) requestAnimationFrame(passo);
        }
        requestAnimationFrame(passo);
      }

      function guarda(){
        if (fatto || toccato) return;
        if (!visibile()) return;
        fatto = true;
        window.removeEventListener('scroll', guarda);
        setTimeout(function(){ if (!toccato) accenna(); }, 350);
      }

      window.addEventListener('scroll', guarda, { passive: true });
      window.addEventListener('resize', guarda);
      guarda();
      cf._kmGuarda = guarda;
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ avvia(document); });
  else avvia(document);
  document.addEventListener('shopify:section:load', function(e){ avvia(e.target); });
})();
